'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var NODE_TYPE = 'nodeType';
var NAMESPACE_URI = 'namespaceURI';
var LOCAL_NAME = 'localName';

var ELEMENT_NODE = 1;
var ATTRIBUTE_NODE = 2;
var TEXT_NODE = 3;
var DOCUMENT_NODE = 9;

exports.NODE_TYPE = NODE_TYPE;
exports.NAMESPACE_URI = NAMESPACE_URI;
exports.LOCAL_NAME = LOCAL_NAME;
exports.ELEMENT_NODE = ELEMENT_NODE;
exports.ATTRIBUTE_NODE = ATTRIBUTE_NODE;
exports.TEXT_NODE = TEXT_NODE;
exports.DOCUMENT_NODE = DOCUMENT_NODE;